import { CUSTOMER_LANGUAGE_TYPES } from '../components/common/customerLanguageTypes';

export type U3120RegularCustomerLabelKey = 'valRegular' | 'valNotRegular';

export function u3120RegularCustomerLabelKey(value: unknown): U3120RegularCustomerLabelKey {
  return value ? 'valRegular' : 'valNotRegular';
}

export function u3120LanguageLabel(value: unknown, locale: string = 'fr'): string {
  if (value == null || value === '') {
    return '';
  }
  const val = String(value);
  const found = CUSTOMER_LANGUAGE_TYPES.find((type) => type.value === val);
  if (!found) {
    return val;
  }
  const lang = locale === 'en' ? 'en' : 'fr';
  return found.label[lang];
}

export function u3120LanguageValues(): string[] {
  return CUSTOMER_LANGUAGE_TYPES.map((type) => type.value);
}
